// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information_information__FAWBS {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  min-height: 112px;
}
.information_inner__U83LD {
  border-radius: 16px;
  border: 1px solid #57b4ba;
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  width: 100%;
  margin-bottom: 16px;
  position: relative;
}

.information_title__-aL3c {
  width: 100%;
  display: flex;
  padding: 12px;
  align-items: center;
  background: #507687;
  /* backdrop-filter: blur(8px); */
  border-radius: 72px;
  border: 1px solid #57b4ba;
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  justify-content: center;
}
.information_title__-aL3c span {
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
}
.information_items__Yg3YX {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 16px;
  padding-top: 20px;
}
.information_item__FYTLZ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  position: relative;
}
.information_number__XzUOL {
  color: #ff5938;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
}
.information_arrow__N-xer {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.information_text__OKpW8 {
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px;
}
.information_line__-VkAX {
  width: 1px;
  background: rgba(252, 252, 237, 0.2);
  height: 24px;
}
.information_gold__qi37S {
  color: #f7ff65;
}
`, "",{"version":3,"sources":["webpack://./src/components/information/information.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB;;;;0CAIwC;EACxC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB;;;;0CAIwC;EACxC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,cAAc;AAChB","sourcesContent":[".information {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 16px;\n  min-height: 112px;\n}\n.inner {\n  border-radius: 16px;\n  border: 1px solid #57b4ba;\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  width: 100%;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.title {\n  width: 100%;\n  display: flex;\n  padding: 12px;\n  align-items: center;\n  background: #507687;\n  /* backdrop-filter: blur(8px); */\n  border-radius: 72px;\n  border: 1px solid #57b4ba;\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  justify-content: center;\n}\n.title span {\n  color: #fff;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n}\n.items {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  align-items: center;\n  padding-bottom: 16px;\n  padding-top: 20px;\n}\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  position: relative;\n}\n.number {\n  color: #ff5938;\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n}\n.arrow {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n.text {\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 36px;\n}\n.line {\n  width: 1px;\n  background: rgba(252, 252, 237, 0.2);\n  height: 24px;\n}\n.gold {\n  color: #f7ff65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"information": `information_information__FAWBS`,
	"inner": `information_inner__U83LD`,
	"title": `information_title__-aL3c`,
	"items": `information_items__Yg3YX`,
	"item": `information_item__FYTLZ`,
	"number": `information_number__XzUOL`,
	"arrow": `information_arrow__N-xer`,
	"text": `information_text__OKpW8`,
	"line": `information_line__-VkAX`,
	"gold": `information_gold__qi37S`
};
export default ___CSS_LOADER_EXPORT___;
